import { useContext } from "react";

import { NativeTransportContext } from "domains/native/transports/context";
import { NativeTransport } from "domains/native/types";

export const useNativeTransport = (): NativeTransport | null => {
    return useContext(NativeTransportContext);
};
